(function () {
    if (!window.location.pathname.match(/\/pages\/paquetes-auto-y-hotel(\/.+)?/g)) return;
    /* setup external dependencies */
    var featherlight = require('featherlight');
    var hotels = require('../modules/TableLocationFiltering');

    hotels.getLocations = function ($locations) {
        var locations = [];
        $locations.each(function (i, e) {
            var el = $(e).data('location');
            if ($.inArray(el, locations) === -1) locations.push(el);
        });
        var newLocations = [];
        $.each(locations, function (i, el) {
            newLocations.push(new hotels.Location(el));
        });
        newLocations.sort();
        return newLocations;
    };
    hotels.addLocationClasses = function ($locations) {
        $locations.each(function (i, e) {
            $(e)
                .closest('tr')
                .addClass(hotels.slugify($(e).data('location')));
        });
    };
    /* setup jQuery opjects */
    var $dropdown = $('select#locations');
    var $locationElements = $('tbody tr');
    var $button = $('#update-table');

    /* actions */
    hotels.setupFiltering($locationElements, $button, $dropdown);
    hotels.addToDropdown(hotels.getLocations($locationElements), $dropdown);
})();
